import { QueryHookOptions } from "@apollo/client";

import { HarvestAccountConfigs } from "@ctypes";
import { HARVEST_ACCOUNT_DEFAULT_CONFIGS } from "@graphql";
import { useQuery } from "@hooks/apollo";

export type HarvestAccountDefaultConfigsQuery = {
  harvestAccountDefaultConfigs?: HarvestAccountConfigs | null;
};

export const useHarvestAccountDefaultConfigs = (
  options?: QueryHookOptions<HarvestAccountDefaultConfigsQuery, Record<string, never>>,
) => {
  const { data, ...rest } = useQuery<HarvestAccountDefaultConfigsQuery, Record<string, never>>(
    HARVEST_ACCOUNT_DEFAULT_CONFIGS,
    {
      fetchPolicy: "cache-and-network",
      ...options,
    },
  );

  return {
    harvestAccountDefaultConfigs: data?.harvestAccountDefaultConfigs,
    ...rest,
  };
};
